import React, { useEffect, useMemo, useState } from 'react';
import { ChatbotDataContext } from './ChatbotDataContext';
import analytics from '../analytics/analytics';
let chatRguid = '';
/**
 * Data provider for Chatbot
 * @public
 */
export const ChatbotDataProvider = props => {
  const {
    chatContainerHeight,
    setCachedMessages,
    setCachedPrompts,
    cachedMessages = [],
    // Sending these will cause error in openAI but are good for display
    cachedPrompts = [],
    // Safe to send to openAI
    submitChatMessagesPayload,
    handleMarkerResponse,
    fetchRequestOptions,
    markerComponents,
    logFirstMessageSubmitted,
    logCustomerCarePhoneNumberDisplayed,
    logCustomerCarePhoneNumberClicked,
    enableVoice,
    enableVoiceTooltip,
    sentenceArrayBuilder,
    speechFetcher,
    quickActions,
    quickActionsStackVariant,
    isMobile,
    livePersonOptions,
    setiValues,
    debugMode,
    discoveryCitySelected,
    speechFetchRequestOptions,
    transcriptionFetchRequestOptions,
    audioPlayerRef,
    openErrorComponent,
    isRealtime,
    setOpenErrorComponent,
    isDev,
    setChatMessages,
    chatMessages,
    prompts,
    setPrompts,
    setLoadingStatus,
    setLoadMoreMessages,
    isLoading,
    loadMoreMessages,
    shouldDisplayGenHotelFeature,
    startRealTime,
    setStartRealTime,
    isMapOpened,
    setOpenedMap,
    componentVersion
  } = props;
  const {
    pushPrompt,
    enabledActions
  } = submitChatMessagesPayload !== null && submitChatMessagesPayload !== void 0 ? submitChatMessagesPayload : {};
  const [errorMessage, setErrorMessage] = useState('');
  // ChatMessages keeps the data that would display to the user
  // Prompts keeps the data that would submit to the api
  const [isDisablingInput, setIsDisablingInputValue] = useState(false);
  const [fullStreamingTexts, setStreamingText] = useState('');
  // Google Maps
  const [locationPinList, appendNewPinToList] = useState([]);
  const [hotelOnMapList, setHotelPinOnMap] = useState([]);
  const funcValues = useMemo(() => ({
    setErrorMessage,
    setLoadingStatus,
    setChatMessages,
    setPrompts,
    setIsDisablingInputValue,
    setStreamingText,
    setOpenErrorComponent,
    setLoadMoreMessages,
    // Google Maps
    setHotelPinOnMap: list => {
      setHotelPinOnMap(list);
    },
    appendNewPinToList: ({
      singlePin,
      listOfPins = []
    }) => {
      if (listOfPins.length !== 0) {
        appendNewPinToList([...listOfPins]);
      } else if (singlePin) {
        appendNewPinToList([...locationPinList, singlePin]);
      }
    },
    setOpenedMap,
    setStartRealTime
  }), [setErrorMessage, setLoadingStatus, setChatMessages, setPrompts, setIsDisablingInputValue, setStreamingText, setOpenErrorComponent, setLoadMoreMessages,
  // Google Maps
  setHotelPinOnMap, appendNewPinToList, setOpenedMap, setStartRealTime]);
  // Preserve chatRguid from submitChatMessagesPayload
  // So on client side, once the Dialog is closed and reopen, there will be a new rguid
  // we need keep to use the same chatRguid.
  if (!chatRguid) {
    chatRguid = submitChatMessagesPayload.rguid;
  } else {
    submitChatMessagesPayload.rguid = chatRguid;
  }
  const contextValues = Object.assign({
    startRealTime,
    setStartRealTime,
    discoveryCitySelected,
    chatContainerHeight,
    setCachedMessages,
    setCachedPrompts,
    cachedMessages,
    cachedPrompts,
    submitChatMessagesPayload,
    handleMarkerResponse,
    fetchRequestOptions,
    markerComponents,
    logFirstMessageSubmitted,
    logCustomerCarePhoneNumberDisplayed,
    logCustomerCarePhoneNumberClicked,
    quickActions,
    quickActionsStackVariant,
    isMobile,
    isRealtime,
    livePersonOptions,
    debugMode,
    openErrorComponent,
    isDev,
    loadMoreMessages,
    // global state values
    errorMessage,
    isLoading,
    chatMessages,
    prompts,
    isDisablingInput,
    fullStreamingTexts,
    enableVoice,
    enableVoiceTooltip,
    sentenceArrayBuilder,
    speechFetcher,
    setiValues,
    speechFetchRequestOptions,
    transcriptionFetchRequestOptions,
    pushPrompt,
    audioPlayerRef,
    shouldDisplayGenHotelFeature,
    // Google Maps
    locationPinList,
    hotelOnMapList,
    isMapOpened,
    componentVersion,
    shouldUseMapFeature: enabledActions === null || enabledActions === void 0 ? void 0 : enabledActions.shouldEnableInlineLocationMetadata
  }, funcValues);
  useEffect(() => {
    analytics.init(contextValues);
  }, []);
  return React.createElement(ChatbotDataContext.Provider, {
    value: contextValues
  }, props.children);
};